<p-breadcrumb
  [model]="[
    {
      label: 'Transportadoras',
      routerLink: ['/carriers'],
    },
  ]"
  [home]="{ label: '', routerLink: ['/'], icon: 'ph-duotone ph-house text-lg' }"
/>

<p-toolbar class="mb-5 mt-5">
  <div class="w-full flex justify-between items-center">
    <div>
      <h5 class="font-bold">Transportadoras</h5>
      <p>Gerencie as transportadoras cadastradas</p>
    </div>

    <p-button
      label="Nova Transportadora"
      routerLink="/carriers/create"
      rounded
    />
  </div>
</p-toolbar>

<p-table
  #table
  [value]="carriers()"
  [lazy]="true"
  (onLazyLoad)="loadData($event)"
  [paginator]="true"
  [paginatorStyleClass]="'flex justify-end!'"
  [rows]="pageSize()"
  [rowsPerPageOptions]="[10, 20, 50]"
  [totalRecords]="totalRecords()"
  [loading]="loading()"
  [first]="paginationService.pageToFirst(pageNumber(), pageSize())"
  paginatorLocale="pt-BR"
>
  <ng-template #caption>
    <div class="flex gap-5">
      <div class="w-100">
        <label for="nameFilter">Nome</label>
        <input
          pInputText
          type="text"
          id="nameFilter"
          class="block"
          [(ngModel)]="nameFilter"
          (ngModelChange)="onFilterChange()"
          placeholder="Filtrar pelo nome"
          fluid
        />
      </div>
    </div>
  </ng-template>

  <ng-template #header>
    <tr>
      <th>Nome</th>
      <th>Website</th>
      <th>Rastreamento</th>
      <th>Status</th>
      <th>Ações</th>
    </tr>
  </ng-template>

  <ng-template #body let-item>
    <tr>
      <td>{{ item.name }}</td>

      <td>
        @if (item.websiteUrl) {
          <a
            class="text-primary underline"
            [href]="item.websiteUrl"
            target="_blank"
          >
            {{ item.websiteUrl }}
          </a>
        } @else {
          -
        }
      </td>

      <td>
        @if (item.trackingUrl) {
          <a
            class="text-primary underline"
            [href]="item.trackingUrl"
            target="_blank"
          >
            {{ item.trackingUrl }}
          </a>
        } @else {
          -
        }
      </td>

      <td>
        <div
          class="flex justify-start"
          (click)="requestUpdateStatus(item, $event)"
        >
          <div class="flex items-center gap-2">
            <p-toggleswitch
              [ngModel]="item.isActive"
              [style.pointer-events]="'none'"
            ></p-toggleswitch>
            {{ item.isActive ? "Ativo" : "Inativo" }}
          </div>
        </div>
      </td>

      <td>
        <p-button
          icon="ph ph-pencil"
          class="mr-2"
          [rounded]="true"
          [outlined]="true"
          [routerLink]="'/carriers/update/' + item.id"
        ></p-button>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="5">
        <p class="text-center">Nenhum registro encontrado!</p>
      </td>
    </tr>
  </ng-template>
</p-table>

<p-toast />
<p-confirmdialog />
